import dayjs from "utils/day";

export const formatDate = (date: any, format = "DD/MM/YYYY"): string => {
  return dayjs(date).format(format);
};
export const formatHHmmDate = (date: any): string => {
  return dayjs(date).format("HH:mm - DD/MM/YYYY");
};
export const formatHour = (val: string, format = ""): string => {
  if (format) {
    return dayjs(val, format).format("LT");
  }
  return dayjs(val).format("LT");
};
export const format24h = (val: string): string => {
  return dayjs(val).format("HH:mm");
};
